import React, { Component } from 'react';
import { HeaderSub } from '../../Common/HeaderSub'
import { LiveChatDig } from './LiveChatDig';
import { LiveChatGoods } from './LiveChatGoods';
import { LiveChatOrder } from './LiveChatOrder';

import { Big3Common } from '../../../js/IncludeManager'

/* 개발담당:양유빈
 * 화면기능:라이브채팅 Index
 * 세부설명:
*/

export class Index extends Component {
    static displayName = Index.name;

    constructor(props) {
        super(props);
        this.state = {
            RenderName: this.CompName.LiveChatDig,  //기본 컴포넌트 할당
            ContentState: null
        };
        const Param_Uid = Big3Common.Util.GetParams("uid"); 
        this.state.ContentState = { Uid: Param_Uid };
    }
    //호출할 컴포넌트 이름
    CompName = {
        "LiveChatDig": "LiveChatDig",
        "LiveChatGoods": "LiveChatGoods",
        "LiveChatOrder": "LiveChatOrder"
    }
    //초기화
    componentDidMount() {
       
    }
    componentWillUnmount() {
        Big3Common.HistoryBackToClearBackdoor();
    } 
    render() {
        if (this.state.RenderName === this.CompName.LiveChatDig) {
            //채팅다이얼로그
            return (
                <div>
                    <HeaderSub
                        HeaderTitle=""
                        HistoryBack={true}
                        ComponentName={this.state.RenderName}
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                    />
                    <LiveChatDig
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.LiveChatGoods) {
            //상품목록
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="상품목록"
                        ComponentUrl="LiveChatDig"
                        ComponentName={this.state.RenderName}
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                    <LiveChatGoods
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.LiveChatOrder) {
            //주문목록
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="주문목록"
                        ComponentUrl="LiveChatDig"
                        ComponentName={this.state.RenderName}
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                    <LiveChatOrder
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }
    }
}
